import React from 'react'
import BgVideo from '../../images/Production/IMG_6297.MP4'
import AnimatedElement from '../../components/AnimatedElement'

import TransitionPage from '../../TransitionPage'
import RevealText from '../../components/TextReveal2'

import Machinery from '../../images/Production/machinery.png'
import Microscope from '../../images/Production/microscope.png'
import Personnel from '../../images/Production/personnel.png'
import Automate from '../../images/Production/recovery.png'

function Production() {
    return (
        <TransitionPage>

            <div className='h-auto pb-14 bg-gray-100'>
                <div className='relative flex items-center justify-center '>
                    <div className='absolute z-40'>
                        <RevealText text='Electronics Manufacturing' css='uppercase text-[3rem] after:bg-black max-sm:text-[1rem] bg-black p-3 bg-opacity-60 font-bold text-white' />
                    </div>
                    <video muted autoPlay loop className='brightness-[0.8]  mix-blend-normal' height='50vh' width="100%">
                        <source src={BgVideo} />
                    </video>
                    <div className='absolute h-full w-full top-0 left-0 '></div>
                </div>
                <div className='flex max-sm:flex-col gap-5 mt-10 px-14 max-sm:px-3'>

                    <AnimatedElement direction='from-down'>
                        <div className='flex-[3]  h-full  px-10 max-sm:px-2'>
                            <p className='text-justify'>
                                <RevealText text='The Electronics Manufacturing' css='text-[2rem] text-left after:bg-black max-sm:text-[1.2rem] font-bold uppercase' />

                                <span className='text-[16px]'>
                                    is, where raw materials are transformed into
                                    finished products with precision and efficiency. Comprising skilled technicians, supervisors, and engineers, this department makes sure that all the different steps in making products undertaken smoothly and on time to meet what the customers desire.
                                    Whether it's assembly lines, machining centers, or custom fabrication, our production facilities are equipped with state-of-the-art machinery and technologies to streamline operations and
                                    enhance productivity.


                                </span>
                            </p>
                        </div>
                    </AnimatedElement>
                </div>

                <div className='mt-10'>
                  
                    <RevealText text='Facilities' css='uppercase text-[3rem] max-sm:text-[2rem] after:bg-[#425472] font-bold text-[#425472]' />

                    <div className='flex flex-col font-semibold max-sm:font-normal items-start px-[100px] max-sm:px-3  gap-3 mt-6'>

                        <div className='flex max-sm:flex-col  items-center justify-center w-full'>
                            <AnimatedElement direction='from-down'>
                                <Facility fac='Machineries like Automatic Screen Printer, Automatic Pick & Place Machine and more' img={Machinery} width={100} />
                            </AnimatedElement>

                            <AnimatedElement direction='from-down' delayAn='0.2'>
                                <Facility fac='Automatized testing process to match with speed of production.' img={Automate} width={100} />
                            </AnimatedElement>

                            <AnimatedElement direction='from-down' delayAn='0.23'>
                                <Facility fac='Devices like Lynx Evo Optical Microsystem having 3D optics, Digital video Microscope.' img={Microscope} width={100} />
                            </AnimatedElement>

                            <AnimatedElement direction='from-down' delayAn='0.26'>
                                <Facility fac='Testing facility is staffed with trained and experienced man power' img={Personnel} width={100} />
                            </AnimatedElement>

                        </div>
                    </div>
                    </div>
            </div >
        </TransitionPage>
    )
}

export default Production

function Facility({ fac, img, width }) {
    return (

        <div className='font-bold scale-90 text-[16px] text-justify max-w-[500px] flex flex-1 flex-col-reverse gap-3 items-center justify-evenly rounded-xl bg-gray-200 text-[#2f3746] p-3 py-[50px] max-sm:py-4 shadow-md hover:scale-95 transition'>
            <p>{fac}</p>
            <img alt='mech' src={img} width={width} />
        </div>
    )
}